import api from '../../plugins/api';

const uploadFileToClient = (params) => {
  return api.post('/api/crm/clients/uploadFileToClient', params);
};

export default uploadFileToClient;
